import React, { useContext, useState } from "react";
import IOrder from "../../../../models/IOrder";
import OwTranslate from "../../OwTranslate/OwTranslate";
import moment from "moment-timezone";
import OwTitle from "../../OwTitle/OwTitle";
import SupplierContext from "../../../../contexts/SupplierContext";
import UserContext from "../../../../contexts/UserContext";
import "./BillOfLadingDetail.scss";
import OwLabel from "../../OwLabel/OwLabel";
import IAddress from "../../../../models/IAddress";
import UIService from "../../../../services/UIService";
import { WhiteLabelLogo } from "../../WhiteLabelLogo/WhiteLabelLogo";
import UserService from "../../../../services/UserService";
import CatalogItemService from "../../../../services/CatalogItemService";
import { DocLogo } from "../../DocLogo/DocLogo";
import { CatalogItemDescription } from "../../CatalogItemDescription/CatalogItemDescription";

type Props = {
    order: IOrder;
};

export const BillOfLadingDetail: React.FC<Props> = (props) => {
    const supplierModel = useContext(SupplierContext);
    const userModel = useContext(UserContext);

    const [showEmail, setShowEmail] = useState(false);
    const [showPhone, setShowPhone] = useState(true);

    const supplierShipTo = supplierModel.Ship_To;
    const shipmentGroupBillTo = supplierShipTo;
    const shipmentGroupShipTo = props.order.Ship_To || ({} as IAddress);

    let tableTheme = "";

    if (!UIService.isMainViewLight()) {
        tableTheme = "table-dark";
    }

    let totalQty = 0;

    const generateItemRows = () => {
        return props.order.Order_Items.map((orderItem) => {
            totalQty += orderItem.qty;

            return (
                <tr key={orderItem.guid}>
                    <td>{orderItem.Catalog_Item?.sku}</td>
                    {supplierModel.has_lots ? <td>{orderItem.Catalog_Item?.sku}</td> : null}
                    <td>
                        {orderItem.description || orderItem.Catalog_Item ? (
                            <CatalogItemDescription
                                catalogItem={orderItem.Catalog_Item!}
                                orderItem={orderItem}
                                priceGroup={props.order?.Price_Group}
                            />
                        ) : (
                            ""
                        )}
                    </td>
                    <td className={"text-end"}>{orderItem.qty}</td>
                </tr>
            );
        });
    };

    const orderItemRows = generateItemRows();

    return (
        <div className={"BillOfLadingDetail"}>
            <div className={"top-row"}>
                <div className={"d-flex p-1"}>
                    <div className={"w-50"}>
                        {supplierModel.Doc_Logo ? <DocLogo maxWidth={"20rem"} height={"auto"} /> : <WhiteLabelLogo maxWidth={"20rem"} />}
                        <div>
                            <OwTitle disableTranslation={true} title={supplierModel.name} tag={"h5"} className={"mb-0"} />
                            <div>{supplierShipTo.address_line_one}</div>
                            <div>{supplierShipTo.address_line_two}</div>
                            <div>
                                {supplierShipTo.city}, {supplierShipTo.state} {supplierShipTo.postal_code}
                            </div>
                            <div className={"mt-2"}>
                                <div className={showPhone && supplierModel.phone ? "" : "d-none"}>
                                    <b>
                                        <OwTranslate defaultMessage={"phone"} id={"phone"} />:
                                    </b>{" "}
                                    {supplierModel.phone}
                                </div>
                                <div className={showEmail && supplierModel.email ? "" : "d-none"}>
                                    <b>
                                        <OwTranslate defaultMessage={"email"} id={"email"} />:
                                    </b>{" "}
                                    {supplierModel.email}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={"w-50 text-end align-items-end d-none d-md-flex flex-column d-print-flex"}>
                        <OwTitle title={"bill_of_lading"} tag={"h3"} isBold={true} />
                        <div>
                            <OwLabel title={"date"} postText={":"} /> {moment().format("MM/DD/YYYY")}
                        </div>
                        <div className={"mt-3"}>
                            <OwLabel title={"purchase_order_no"} postText={":"} isBold={true} />
                            <span className={"d-inline-block w-8r border-bottom border-dark"}>{props.order.po_no}</span>
                        </div>
                        <div>
                            <OwLabel title={"shipper_order_no"} postText={":"} isBold={true} />
                            <span className={"d-inline-block w-8r border-bottom border-dark"}>{props.order.name}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div className={"mt-4 d-flex"}>
                <div className={"w-50"}>
                    <OwLabel title={"shipping_method"} postText={":"} className={"me-2"} />
                    <b>{props.order.shipping_method}</b>
                </div>
                <div className={"w-50"}>
                    <OwLabel title={"delivery_date"} postText={":"} className={"me-2"} />
                    <b>{UserService.parseUTCDate(props.order.delivery_date)}</b>
                </div>
            </div>

            <div className={"bill-to-ship-to-row d-flex"}>
                <div className={"w-50 black-box p-1"}>
                    <OwTitle leftIconName={"fal fa-truck"} className={"underline"} title={"from"} tag={"h5"} />
                    <OwTitle
                        tag={"h5"}
                        disableTranslation={true}
                        title={shipmentGroupBillTo.name || shipmentGroupBillTo.company_name || props.order.Vendor!.name}
                        className={"mb-0"}
                    />
                    <div>{shipmentGroupBillTo.address_line_one}</div>
                    <div>{shipmentGroupBillTo.address_line_two}</div>
                    <div>
                        {shipmentGroupBillTo.city}, {shipmentGroupBillTo.state} {shipmentGroupBillTo.postal_code}
                    </div>
                </div>

                <div className={"w-50 black-box border-left-0 p-1"}>
                    <OwTitle leftIconName={"fal fa-flag-checkered"} title={"to"} tag={"h5"} className={"underline"} />
                    <OwTitle
                        tag={"h5"}
                        disableTranslation={true}
                        title={shipmentGroupShipTo.name || shipmentGroupShipTo.company_name || props.order.Vendor!.name}
                        className={"mb-0"}
                    />
                    <div>{shipmentGroupShipTo.address_line_one}</div>
                    <div>{shipmentGroupShipTo.address_line_two}</div>
                    <div>
                        {shipmentGroupShipTo.city}, {shipmentGroupShipTo.state} {shipmentGroupShipTo.postal_code}
                    </div>
                </div>
            </div>

            <div className={"mt-4"}>
                <div className={"w-100 table-responsive"}>
                    <table className={"table table-bordered " + tableTheme}>
                        <tbody>
                            <tr>
                                <th>
                                    <OwLabel title={"sku"} className={"mb-0"} />
                                </th>
                                {supplierModel.has_lots ? (
                                    <th>
                                        <OwLabel title={"lot"} className={"mb-0"} />
                                    </th>
                                ) : null}
                                <th>
                                    <OwLabel title={"description"} className={"mb-0"} />
                                </th>
                                <th className={"text-end"}>
                                    <OwLabel title={"qty"} className={"mb-0"} />
                                </th>
                            </tr>
                            {orderItemRows}
                        </tbody>
                        <tbody>
                            <tr>
                                <td>
                                    <OwLabel title={"total"} isBold={true} />
                                </td>
                                {supplierModel.has_lots ? <td></td> : null}
                                <td></td>
                                <td className={"w-15 text-end"}>{totalQty}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div className={"signature-bottom mt-5"}>
                <div className="mt-4 d-flex">
                    <div className={"w-50 black-box d-flex flex-column"}>
                        <div className={"border-bottom border-dark p-1 d-flex flex-grow-1 text-small pre-wrap"}>
                            {supplierModel.bill_of_lading_details.shipperLegalCopy}
                        </div>
                        <div className={"d-flex p-1 h-3r align-items-end"}>
                            <div className={"w-75"}>
                                <OwLabel title={"shipper_signature"} />
                            </div>
                            <div>
                                <OwLabel title={"date"} />
                            </div>
                        </div>
                    </div>
                    <div className={"w-50 black-box border-left-0 d-flex flex-column"}>
                        <div className={"border-bottom border-dark p-1 d-flex flex-grow-1 text-small pre-wrap"}>
                            {supplierModel.bill_of_lading_details.receiverLegalCopy}
                        </div>
                        <div className={"d-flex p-1 h-3r align-items-end"}>
                            <div className={"w-75"}>
                                <OwLabel title={"receiver_signature"} />
                            </div>
                            <div>
                                <OwLabel title={"date"} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
